import { render, staticRenderFns } from "./ContractNotes.vue?vue&type=template&id=52751d82&"
import script from "./ContractNotes.vue?vue&type=script&lang=js&"
export * from "./ContractNotes.vue?vue&type=script&lang=js&"
import style0 from "./ContractNotes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports